import * as commonConsts from '../../../../pages/common/CommonConsts';
import {
  isNumeric,
  isSelected,
  isCompleted,
  isValidEmail,
  isAustralianPhoneNumberWithCountryCodeOrNull,
  isAustralianPhoneNumberWithOutCountryCodeOrNull
} from '../../../../utils/Validation';

const getAddValidatorsIndividualAuditor = (props) => [
  {
    fieldName: 'auditorType',
    fieldValue: props.auditorType,
    isValid: (v) => isSelected(v)
  },
  {
    fieldName: 'firstName',
    fieldValue: props.individualFirstName,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'lastName',
    fieldValue: props.individualLastName,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'qualification',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      return isCompleted(v?.qualifications);
    }
  },
  {
    fieldName: 'qualificationCertificateNumber',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.qualifications === commonConsts.qualificationNoFormal) {
        return true;
      } else if (v?.qualifications === commonConsts.qualificationRegisteredCompanyAuditor) {
        return isCompleted(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationCertificateNumberValid',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.certificateNumber?.length > 0) {
        return isNumeric(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationNoFormalDescription',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.qualifications !== commonConsts.qualificationNoFormal) {
        return true;
      } else {
        return v?.qualifications === commonConsts.qualificationNoFormal && isCompleted(v?.details);
      }
    }
  },
  {
    fieldName: 'emailAddress',
    fieldValue: props.individualEmailAddress,
    isValid: (v) => isValidEmail(v)
  },
  {
    fieldName: 'primaryContactPrefix',
    fieldValue: props.individualPrimaryContactNumber,
    isValid: (v) => {
      if (v.prefix === '') {
        return false;
      }

      if (Array.isArray(v.prefix)) {
        return false;
      }

      const validPrefix = commonConsts.australianPhonePrefixes.find((x) => x === v.prefix);
      if (validPrefix) {
        return true;
      } else {
        return false;
      }
    }
  },
  {
    fieldName: 'primaryContactNumber',
    fieldValue: props.individualPrimaryContactNumber,
    isValid: (v) => {
      if (v.number === null) {
        return false;
      }

      if (v.prefix === commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithCountryCodeOrNull(v.number);
      }

      if (v.prefix !== commonConsts.australianCountryCode) {
        return isAustralianPhoneNumberWithOutCountryCodeOrNull(v.number);
      }
    }
  },
  {
    fieldName: 'businessAddress',
    fieldValue: {
      individualIsBusinessAddressValid: props.individualIsBusinessAddressValid
    },
    isValid: (v) => {
      return v.individualIsBusinessAddressValid;
    }
  },
  {
    fieldName: 'postalAddress',
    fieldValue: {
      sameAsBusinessAddress: props.individualSameAsBusinessFlag,
      individualIsBusinessAddressValid: props.individualIsBusinessAddressValid,
      individualIsPostalAddressValid: props.individualIsPostalAddressValid
    },
    isValid: (v) => {
      let result;

      if (v.sameAsBusinessAddress) {
        result = v.individualIsBusinessAddressValid;
      }

      return v.individualIsPostalAddressValid;
    }
  }
];

const getEditValidatorsIndividualAuditor = (props) => [
  {
    fieldName: 'qualification',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      let res = isCompleted(v?.qualifications);
      return res;
    }
  },
  {
    fieldName: 'qualificationCertificateNumber',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.qualifications === commonConsts.qualificationNoFormal) {
        return true;
      } else if (v?.qualifications === commonConsts.qualificationRegisteredCompanyAuditor) {
        return isCompleted(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationCertificateNumberValid',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.certificateNumber?.length > 0) {
        return isNumeric(v?.certificateNumber);
      } else {
        return true;
      }
    }
  },
  {
    fieldName: 'qualificationNoFormalDescription',
    fieldValue: props.individualQualification,
    isValid: (v) => {
      if (v?.qualifications !== commonConsts.qualificationNoFormal) {
        return true;
      } else {
        return v?.qualifications === commonConsts.qualificationNoFormal && isCompleted(v?.details);
      }
    }
  }
];

const errorsIndividualDefaultValue = {
  auditorType: false,
  firstName: false,
  middleName: false,
  lastName: false,
  qualification: false,
  qualificationCertificateNumber: false,
  qualificationCertificateNumberValid: false,
  qualificationNoFormalDescription: false,
  emailAddress: false,
  primaryContactPrefix: false,
  primaryContactNumber: false,
  businessAddress: false,
  postalAddress: false
};

export { getAddValidatorsIndividualAuditor, getEditValidatorsIndividualAuditor, errorsIndividualDefaultValue };
